import styles from './Filter.module.css';

import React from 'react';

import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';
import Icon from '@mui/material/Icon';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import Search from '@mui/icons-material/Search';

export const Filter = ({ filters, filterItems = false, onFilterChange, onClearFilters }) => {
    const [ isExpanded, setIsExpanded ] = React.useState(false);

    const toggleExpanded = () => setIsExpanded(!isExpanded);

    const handleInputChange = (field, value) => {
        onFilterChange({ ...filters, [ field ]: value });
    };

    const hasActiveFilters = filters.search || filters.showCashTags || filters.showDonatedItems || filters.showVerifiedItems || filters.showSoldItems || filters.showPaidOutItems || filters.invertFilters;

    return (
        <div className={ styles.filterContainer }>
            <div className={ styles.filterHeader } onClick={ toggleExpanded }>
                <span>
                    { hasActiveFilters && <span className={ styles.activeIndicator }>●&nbsp;</span> }
                    <Icon component={ Search } sx={ { mr: 1 } } />
                    <Typography>Search</Typography>
                </span>

                <span>
                    <Icon component={ isExpanded ? ExpandLess : ExpandMore } />
                </span>
            </div>

            <div className={ `${ styles.filterContent } ${ isExpanded ? styles.expanded : styles.collapsed }` }>
                <Stack direction="column" spacing={ 2 } alignItems="left" className={ styles.filterRow }>
                    <input
                        type="text"
                        placeholder="Search by name, email, phone, or vendor name"
                        value={ filters.search }
                        onChange={ (e) => handleInputChange('search', e.target.value) }
                        className={ styles.searchInput }
                    />
                </Stack>

                { filterItems && <Divider sx={ { my: 2 } } /> }

                { filterItems && <Stack direction="column" spacing={ 2 } alignItems="left" className={ styles.filterRow }>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={ filters.showVerifiedItems || false }
                                onChange={ (e) => handleInputChange('showVerifiedItems', e.target.checked) }
                            />
                        }
                        label="Show Verified Items"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={ filters.showPaidOutItems || false }
                                onChange={ (e) => handleInputChange('showPaidOutItems', e.target.checked) }
                            />
                        }
                        label="Show Paid Out Items"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={ filters.showSoldItems || false }
                                onChange={ (e) => handleInputChange('showSoldItems', e.target.checked) }
                            />
                        }
                        label="Show Sold Items"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={ filters.showDonatedItems || false }
                                onChange={ (e) => handleInputChange('showDonatedItems', e.target.checked) }
                            />
                        }
                        label="Show Donated Items"
                    />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={ filters.showCashTags || false }
                                onChange={ (e) => handleInputChange('showCashTags', e.target.checked) }
                            />
                        }
                        label="Show Cash Tags"
                    />

                    <Divider />

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={ filters.invertFilters || false }
                                onChange={ (e) => handleInputChange('invertFilters', e.target.checked) }
                            />
                        }
                        label="Invert Filters"
                    />
                </Stack> }

                { hasActiveFilters && <Divider sx={ { my: 2 } } /> }

                { hasActiveFilters && (
                    <Button
                        variant={ hasActiveFilters ? "contained" : "outlined" }
                        className={ styles.clearButton }
                        onClick={ onClearFilters }
                    >
                        Clear Filters
                    </Button>
                ) }
            </div>
        </div>
    );
};